import PmaxWorkspace from '@/components/google-ads/performance-max/PmaxWorkspace';
import { SALES_OBJECTIVE } from './salesObjective';

/** SALES WORKSPACE — /google-ads/sales */
export default function SalesPage() {
  return <PmaxWorkspace objective={SALES_OBJECTIVE} />;
}
